__turbopack_context__.v({
  "brand": "Footer-module__k72PMq__brand",
  "footer": "Footer-module__k72PMq__footer",
  "footerLinks": "Footer-module__k72PMq__footerLinks",
  "footerLogoGrid": "Footer-module__k72PMq__footerLogoGrid",
  "newsletter": "Footer-module__k72PMq__newsletter",
  "newsletterWrapper": "Footer-module__k72PMq__newsletterWrapper",
});
